// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3851I","placeholdersHeader":"styles_placeholdersHeader__2gtOm","editorStyle":"styles_editorStyle__3NlFb","placeholdersBox":"styles_placeholdersBox__2svW4"};